import { Button } from '@/common/ui/Form/Button/Button'
import { Icon } from '@/common/ui/Icon'

type CompanyStatsExcelExportButtonProps = {
    onClick: () => void
    disabled?: boolean
    isLoading?: boolean
    ariaLabel?: string
}

export const CompanyStatsExcelExportButton = ({
    onClick,
    disabled = false,
    isLoading = false,
    ariaLabel = 'Экспорт в Excel',
}: CompanyStatsExcelExportButtonProps) => (
    <Button
        type='button'
        emphasis='secondary'
        size='sm'
        onClick={onClick}
        disabled={disabled || isLoading}
        aria-label={ariaLabel}
    >
        {isLoading ? (
            <span className='loading loading-spinner loading-xs' aria-hidden />
        ) : (
            <Icon name='xls' size='sm' aria-hidden />
        )}
        EXCEL
    </Button>
)
